import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home/profile.jpg'


const _withScopeId = n => (_pushScopeId("data-v-36e1583b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quiz-page" }
const _hoisted_2 = { class: "container-progress" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-progress__profile" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-progress__bar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "container-progress__bar-filled",
    id: "bar"
  })
], -1))
const _hoisted_5 = { class: "container-progress__percent" }
const _hoisted_6 = { class: "container-progress__percent-box" }
const _hoisted_7 = { class: "container-questions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Question = _resolveComponent("Question")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.percentQuiz) + " %", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Question, {
        question: _ctx.currentQuiz.questions[_ctx.id-1],
        onNext: _ctx.handleQuestion,
        total: _ctx.currentQuiz.questions.length
      }, null, 8, ["question", "onNext", "total"])
    ])
  ]))
}